import { useState } from "react";
import { EnumTipoConfigGroupPay } from "constants/EnumTipoConfigGroupPay";
import Tabs from "shared/components/tabs/Tabs";
import TelaListaDespesasGroupPay from "../listaDespesasGroupPay/TelaListaDepesasGroupPay";
import AbaConfiguracoesGroupPay from "./AbaConfiguracoesGroupPay";

const AbasGroupPay: React.FC = () => {
  const [activeTab, setActiveTab] = useState<EnumTipoConfigGroupPay>(
    EnumTipoConfigGroupPay.DESPESAS_ENCONTRADAS
  );

  const abas = [
    {
      id: 1,
      title: "Despesas captadas por IA",
      content: <TelaListaDespesasGroupPay />,
      tipoTab: EnumTipoConfigGroupPay.DESPESAS_ENCONTRADAS,
      
    },
    {
      id: 2,
      title: "Configuração do Group Pay",
      content: <AbaConfiguracoesGroupPay />,
      tipoTab: EnumTipoConfigGroupPay.CONFIGURACAO_GROUP_PAY,
    },
  ];

  return (
      <Tabs
        tabs={abas}
        activeTab={activeTab}
        changeActiveTab={setActiveTab}
        margin="0px"
      />
  );
};

export default AbasGroupPay;